import { render } from "./TestResultCard.vue?vue&type=template&id=18f5eff8&scoped=true"
import script from "./TestResultCard.vue?vue&type=script&lang=js"
export * from "./TestResultCard.vue?vue&type=script&lang=js"

import "./TestResultCard.vue?vue&type=style&index=0&id=18f5eff8&scoped=true&lang=scss"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f5eff8"]])

export default __exports__